import {Inject, Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AppModeDetectorService {

  private readonly appMode: string;

  constructor(@Inject('app_mode') private mode: string) {
    this.appMode = mode
  }

  isBackoffice() {
    if (this.appMode === 'back-office') {
      return true;
    }

    return false;
  }

}
